module.exports = __webpack_public_path__ + "static/37-b1f73cee0b39a3dc950e913ed802fa97.jpg";